import BrandSubscription from "../../../api/BrandSubscription";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { alpha, lighten } from "@mui/material/styles";
import AccessTimeRounded from "@mui/icons-material/AccessTimeRounded";
import React, { useEffect, useState } from "react";
import Button from "../../Button";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { CARD_STYLES, FONTS } from "../../../constants/styles";

const SubscriptionBanner = () => {
    const theme = useTheme();
    const navigate = useNavigate();

    const [cookies] = useCookies(["uuid", "brand_id"]);
    const { uuid, brand_id } = cookies;

    const [subscription, setSubscription] = useState<
        BrandSubscription | undefined
    >();

    useEffect(() => {
        if (!uuid || !brand_id) return;
        BrandSubscription.info(uuid, brand_id).then(setSubscription);
    }, [uuid, brand_id]);

    const onSubscriptionsClick = () => navigate("/menu/subscriptions");

    const calculateDaysLeft = (subscription: BrandSubscription) => {
        const now = new Date();
        const expiryDate = new Date(subscription.finished);

        // Calculate the difference in days
        const diff = Math.round(
            (expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
        );

        return diff;
    };

    if (!subscription || !subscription.trial) {
        return null; // Hide the banner if no subscription or the subscription is not a trial
    }

    const daysLeft = subscription ? calculateDaysLeft(subscription) : 0;
    const isExpired = subscription ? !subscription.valid : true;
    const primary = theme.palette.primary.main;

    return (
        <Stack
            className="force-dynamic-translation"
            direction="column"
            spacing={1.5}
            paddingY={1.5}
            paddingX={2}
            width="100%"
            sx={{
                ...CARD_STYLES,
                boxSizing: "border-box",
                background: `linear-gradient(135deg, ${alpha(primary, 0.04)} 0%, ${alpha(lighten(primary, 0.3), 0.08)} 100%)`,
            }}
        >
            {/* Top row: icon + days info */}
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Box
                    sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "12px",
                        bgcolor: alpha(primary, 0.1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flex: "0 0 auto",
                        color: primary,
                    }}
                >
                    <AccessTimeRounded sx={{ fontSize: 20 }} />
                </Box>
                <Stack spacing={0.125}>
                    <Typography
                        fontWeight={500}
                        fontSize="12px"
                        color="text.secondary"
                    >
                        {subscription?.trial
                            ? "Trial License"
                            : isExpired
                            ? "Subscription Expired"
                            : "Subscription Renews In"}
                    </Typography>
                    {!isExpired && (
                        <Typography
                            fontWeight={700}
                            fontSize="20px"
                            lineHeight={1.2}
                            color={primary}
                            fontFamily={FONTS.display}
                        >
                            {daysLeft} days left
                        </Typography>
                    )}
                </Stack>
            </Stack>

            {/* Promo copy */}
            <Typography fontWeight={600} fontSize="13px" color="text.primary">
                Early access – lock in your price of 1300 UAH/month forever.
            </Typography>

            {/* Call-to-Action */}
            <Button variant="medium" fullWidth onClick={onSubscriptionsClick}>
                Buy a subscription
            </Button>
        </Stack>
    );
};

export default SubscriptionBanner;
